import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

export default function Loading({ loading, children, hasTip = true, tip = 'Загрузка...' }) {
    return (
        <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} tip={hasTip ? tip : ''}>
            {children}
        </Spin>
    );
}
